// @flow

import type {MarkdocFragmentRegistration} from 'docs/markdoc';

export const Comment: MarkdocFragmentRegistration = {
  tag: 'comment',
  localize: false,
  render(node, config) {
    return [];
  },
};
